//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import AssetInventoryDrawer from "./modules/AssetInventoryDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'AssetInventoryList',
  mixins: [JeecgListMixin],
  props: ['category'],
  components: {
    AssetInventoryDrawer: AssetInventoryDrawer
  },
  data: function data() {
    return {
      dates: {},
      autoLoadInit: false,
      pagePath: '/asset/inventory',
      pageTitle: '检测仪表',
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '名称',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: '数量',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'expiryDate',
        colName: 'expiry_date',
        title: '保质期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'purchaseDate',
        colName: 'purchase_date',
        title: '购置日期',
        align: 'center',
        sorter: true
      }, // {
      //   dataIndex: 'siteId',
      //   colName: 'site_id',
      //   title: '保管站点',
      //   align: 'center',
      //   sorter: true
      // },
      {
        dataIndex: 'siteName',
        colName: 'site_name',
        title: '贮存点',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'contact',
        colName: 'contact',
        title: '联系人',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'contactTel',
        colName: 'contact_tel',
        title: '联系人电话',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status',
        colName: 'status',
        title: '资产状态',
        align: 'center',
        customRender: function customRender(t, r, index) {
          return r.status_dictText;
        }
      }, // {
      //   dataIndex: 'sort',
      //   colName: 'sort',
      //   title: '排序号',
      //   align: 'center',
      //   sorter: true
      // },
      // {
      //   dataIndex: 'tenantId',
      //   colName: 'tenant_id',
      //   title: '租户ID',
      //   align: 'center',
      //   sorter: true
      // },
      {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    category: {
      handler: function handler(val) {
        if (val) {
          switch (val) {
            case '12':
              this.pageTitle = '检测仪表';
              break;

            case '11':
              this.pageTitle = '运维设备';
              break;

            case '91':
              this.pageTitle = '应急物资';
              break;
          }

          this.queryParam.category = val;
          this.loadData();
        }
      },
      immediate: true
    }
  },
  methods: {
    handleAdd: function handleAdd() {
      this.$refs.modalForm.add({
        category: this.category
      });
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    searchReset: function searchReset() {
      this.queryParam = {
        category: this.category
      };
      this.dates = {};
      this.loadData(1);
    },
    onDateExpiryDate: function onDateExpiryDate(value, dateArray) {
      if (dateArray[0]) {
        this.queryParam.expiryDateStart = dateArray[0] + ' 00:00:00';
        this.queryParam.expiryDateEnd = dateArray[1] + ' 23:59:59';
      }
    },
    onDatePurchaseDate: function onDatePurchaseDate(value, dateArray) {
      if (dateArray[0]) {
        this.queryParam.purchaseDateStart = dateArray[0] + ' 00:00:00';
        this.queryParam.purchaseDateEnd = dateArray[1] + ' 23:59:59';
      }
    }
  }
};